import {Link} from "react-router-dom";
import {Routes} from "../utils";


export default function OrderFinalizedScreen(props) {
  return (
    <div className="container" style={{maxWidth: 600}}>
      <div className="text-center">
        <h3>Dziękujemy za wysłanie zapytania!</h3>
        <p className="mb-4">Sprawdzimy Twoje zamówienie i skontaktujemy się z Tobą.</p>
        <Link to={Routes.home}>
          <span className="btn btn-primary">Rozpocznij od nowa</span>
        </Link>
      </div>

    </div>
  )
}
